import { Form } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import { Organization } from "../models/Organization";
import ErrorsView from "./ErrorsView";

export interface AddBlueprintToOrgFormData {
  organizationId: string;
  permitTypeName: string;
}

interface Props {
  formData: AddBlueprintToOrgFormData;
  formErrors: FormError;
  errors?: string[];
  organizations?: Organization[];
  onChange: (formData: AddBlueprintToOrgFormData) => void;
}

const AddBlueprintToOrganizationForm = ({ formData, formErrors, errors, organizations, onChange }: Props) => {
  const orgOptions =
    organizations?.map((o) => ({
      key: o.id,
      value: o.id,
      text: o.name,
    })) ?? [];

  return (
    <Form>
      <Form.Group widths="equal">
        <Form.Field required>
          <label>Organization</label>
          <Form.Select
            error={formErrors.organizationId}
            name="organizationId"
            value={formData.organizationId ?? ""}
            options={orgOptions}
            onChange={(_, { value }) => onChange({ ...formData, organizationId: value as string })}
            placeholder="Select organization"
            search
          />
        </Form.Field>
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field>
          <label>Permit Type Name (optional override)</label>
          <Form.Input
            name="permitTypeName"
            value={formData.permitTypeName ?? ""}
            onChange={(_, { value }) => onChange({ ...formData, permitTypeName: value })}
            placeholder="Defaults to blueprint name"
          />
        </Form.Field>
      </Form.Group>
      <ErrorsView errors={errors} />
    </Form>
  );
};

export default AddBlueprintToOrganizationForm;

